// extracted by mini-css-extract-plugin
export default {"button":"SelectIcon_button__ENTdg","icon":"SelectIcon_icon__B4a8Q","edit":"SelectIcon_edit__h6qRI","fav":"SelectIcon_fav__v8iIr"};